import script from "./AppSideNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSideNotifications.vue?vue&type=script&setup=true&lang=js"

import "./AppSideNotifications.vue?vue&type=style&index=0&id=90ccfec6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90ccfec6"]])

export default __exports__